<template>
  <b-card
    :title="$t('label_reports_genderGap_genderEqualityIndex_title')"
    :style="{ minHeight: height }"
  >
    <b-row>
      <b-col md="9">
        <p class="card-text">
          {{ $t("label_reports_genderGap_genderEqualityIndex_description") }}
        </p>
      </b-col>
      <b-col>
        <div
          v-if="getGeneralIndexConsolidated"
          id="generalIndex"
          class="general-index center-block"
          :class="
            getGeneralIndexConsolidated >= 50
              ? getGeneralIndexConsolidated > 75
                ? 'positive'
                : 'intermediate'
              : 'negative'
          "
        >
          {{
            getGeneralIndexConsolidated
              | currency("", 0, { thousandsSeparator: "" })
          }}%
        </div>
        <div
          v-if="!getGeneralIndexConsolidated"
          class="general-index center-block negative"
        >
          0%
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CardGeneralIndexConsolidated",
  props: {
    height: {
      type: String,
      default: "auto",
    },
  },
  computed: mapGetters(["getGeneralIndexConsolidated"]),
};
</script>

<style lang="scss" scoped>
/* components/cards/CardGeneralIndex */
.general-index {
  font-size: 3rem;
  border-radius: 20px;
  text-align: center;
}
.col-8 {
  padding-right: 5px;
}
.col {
  padding-left: 5px;
}
.card-title {
  text-align: left;
}
</style>
